<template>
    <div class="center fs18" style="padding-top: 40px;">
        <p class="black fs32 fw500">{{ $t('form1') }}</p>
        <a v-show="false" :href="formUrl" download ref="a" target="_blank"></a>
        <span class="backyel dib divide"></span>
        <div class="left fs18" :class="$style.body">
            <!-- <div class="dflex backgray">
                <span class="dib" :class="$style.left">1. {{ $t('form2') }}</span>
                <span class="f1 dib">{{year}}</span>
                <span class="dib center backyel cp" :class="$style.right" @click="open('https://www.labour.gov.hk/tc/news/latest_holidays2020.htm')">{{ $t('detail') }}</span>
            </div> -->
            <div class="dflex">
                <span class="dib" :class="$style.left">1. {{ $t('form3') }}</span>
                <span class="f1 dib">{{year}}</span>
                <!-- <a class="dib center cp" :class="$style.right" :href="$service.holidayen"  download target="_blank">{{ $t('detail') }}</a> -->
                <span class="dib center cp" :class="$style.right" @click="open(form1Url)">{{ $t('detail') }}</span>
            </div>
            <div class="dflex backgray">
                <span class="dib" :class="$style.left">2. {{ $t('form4') }}</span>
                <span class="f1 dib">{{ $t('form41') }}</span>
                <a class="dib center cp" :class="$style.right" :href="$service.payroll" download target="_blank">{{ $t('download') }}</a>
            </div>
            <div class="dflex">
                <span class="dib" :class="$style.left">3. {{ $t('form5') }}</span>
                <span class="f1 dib">{{ $t('form51') }}</span>
                <a class="dib center cp" :class="$style.right" :href="$service.id4" download target="_blank">{{ $t('download') }}</a>
            </div>
            <div class="dflex">
                <span class="dib" :class="$style.left"></span>
                <span class="f1 dib">{{ $t('form52') }}</span>
                <a class="dib center cp" :class="$style.right" :href="$service.id9" download target="_blank">{{ $t('download') }}</a>
            </div>
            <div class="dflex backgray">
                <span class="dib f1" :class="$style.left">4. {{ $t('form6') }}</span>
                <span class="dib center cp" :class="$style.right" @click="open(form5Url)">{{ $t('detail') }}</span>
            </div>
            <div class="dflex">
                <span class="dib f1" :class="$style.left">5. {{ $t('form7') }}</span>
                <span class="dib center cp" :class="$style.right" @click="open(form6Url)">{{ $t('detail') }}</span>
            </div>
            <div class="dflex backgray">
                <span class="dib f1" :class="$style.left">6. {{ $t('form8') }}</span>
                <a class="dib center cp" :class="$style.right" :href="$service.labor" download target="_blank">{{ $t('detail') }}</a>
            </div>
            <div class="dflex">
                <span class="dib f1" :class="$style.left">7. {{ $t('form9') }}</span>
                <a class="dib center cp" :class="$style.right" :href="$service.url7" download target="_blank">{{ $t('detail') }}</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Form',
    data() {
        const isEng = this.$i18n.locale === 'en';
		const year = (new Date).getFullYear();
        return {
            formUrl: '',
            year: year,
			// year: "2023",
            form1Url: isEng ? 'https://www.labour.gov.hk/eng/news/latest_holidays' + year + '.htm' : 'https://www.labour.gov.hk/tc/news/latest_holidays'+year+'.htm',
            form5Url: isEng ? 'https://www.immd.gov.hk/eng/online-services/index.html' : 'https://www.immd.gov.hk/hkt/online-services/index.html',
            form6Url: isEng ? 'https://www.labour.gov.hk/eng/news/content.htm' : 'https://www.labour.gov.hk/tc/news/content.htm'
        };
    },
    methods: {
        onDownload() {
            this.$refs.a.click();
        },
        open(url) {
            window.open(url);
        }
    },
    created() {
        this.$top();
    }
}
</script>
<style module>
.body {
    margin: 20px 100px 80px 100px;
    line-height: 2.5;
}
.left {
    width: 400px;
    padding-left: 30px;
}
.right {
    width: 140px;
    color: #f3b707e6 !important;
}
.right:hover {
    color: #fff !important;
    background-color: #f3b707e6;
}
@media screen and (max-width: 770px) {
    .body{
        margin: 20px;
    }
    .left {
        width: 40%;
        padding-left: 0px;
    }
    .right {
        width: 17%;
    }
}
</style>
